import * as React from "react";
const WixBookingSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 9h1v1H8V9zm1 2H8v1h1v-1zm-2 0H6v1h1v-1zm3-2h1v1h-1V9zm1 2h-1v1h1v-1z" }), /* @__PURE__ */ React.createElement("path", { d: "M4 4h2V3h1v1h3V3h1v1h2a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1zm0 1v2h9V5h-2v1h-1V5H7v1H6V5H4zm0 3v6h9V8H4z" }));
WixBookingSmall.displayName = "WixBookingSmall";
var WixBookingSmall_default = WixBookingSmall;
export {
  WixBookingSmall_default as default
};
